    export interface IChangePasswordRequest {
        username: string;
        password: string;
    }

    export class ChangePasswordRequest implements IChangePasswordRequest {
        username: string;
        password: string;
    }